module.exports = __webpack_public_path__ + "assets/measure_energy_consumption.ce63cae1.svg";